/* eslint-disable react-hooks/exhaustive-deps */
import { useApi } from '@backstage/core-plugin-api';
import {
  NotificationApi,
  notificationApiRef,
} from '../../../apis/notificationApi';
import { toolsProvisioningApiRef } from '../../../apis/toolsProvisioningApi';
import { useEffect, useState } from 'react';

export const useGetServicesMapping = (
  apmNumber: string,
  shouldcall: boolean,
) => {
  const notificationApi: NotificationApi = useApi(notificationApiRef);
  const toolsprovisioningApi = useApi(toolsProvisioningApiRef);

  const [servicesMapping, setServicesMapping] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchMyAPI = async () => {
    setLoading(true);
    if (!toolsprovisioningApi || !apmNumber) {
      setServicesMapping([]);
      setLoading(false);
      return;
    }

    try {
      const response = await toolsprovisioningApi.getAllServicesMapping(apmNumber);
      setServicesMapping(response || []);
    } catch (error) {
      notificationApi.sendNotification({
        message: `Error occurred - ${error}`,
        disapperAfterMs: 2500,
        severity: 'error',
      });
      setServicesMapping([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (shouldcall) fetchMyAPI();
  }, [shouldcall, apmNumber]);

  return [servicesMapping, loading] as const;
};
